import i18n from "i18next"
import backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "nl",
    languages: ["nl", "en"],
    ns: ["translation"],
    defaultNS: "translation",
    debug: false,
    keySeparator: ">",
    nsSeparator: "|",
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `locales/{{lng}}/{{ns}}.json?20260318`
    }
  })

export default i18n